import { Component, Inject, OnInit } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { ProductoService } from 'app/services/producto.service';

@Component({
  selector: 'app-asociar-productos-dialog',
  templateUrl: './asociar-productos-dialog.component.html',
})
export class AsociarProductosDialogComponent implements OnInit {
  productos: any[] = [];
  productosFiltrados: any[] = [];
  seleccionados: any[] = [];
  search: string = '';
  loading = false;

  constructor(
    public dialogRef: MatDialogRef<AsociarProductosDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: { idProveedor: number, idsActuales?: number[] },
    private productoService: ProductoService
  ) {}

  ngOnInit(): void {
    this.cargarProductos();
  }

  cargarProductos() {
    this.loading = true;
    this.productoService.getArticulos(1, 1000, this.search).subscribe((res: any) => {
      this.productos = res.data || res || [];
      // Filtrar productos ya asociados
      if (this.data && this.data.idsActuales) {
        this.productos = this.productos.filter(p => !this.data.idsActuales.includes(p.id));
      }
      this.productosFiltrados = this.productos;
      this.loading = false;
    });
  }

  filtrarProductos() {
    const term = this.search.toLowerCase();
    this.productosFiltrados = this.productos.filter(p =>
      p.name.toLowerCase().includes(term) || p.code.toLowerCase().includes(term)
    );
  }

  toggleSeleccion(producto: any) {
    const idx = this.seleccionados.findIndex(p => p.id === producto.id);
    if (idx > -1) {
      this.seleccionados.splice(idx, 1);
    } else {
      this.seleccionados.push(producto);
    }
  }

  confirmar() {
    this.dialogRef.close(this.seleccionados);
  }

  cancelar() {
    this.dialogRef.close();
  }
}
